export const supplierConstants = {

    GET_SUPPLIERS_REQUEST: 'GET_SUPPLIERS_REQUEST',
    GET_SUPPLIERS_SUCCESS: 'GET_SUPPLIERS_SUCCESS',
    GET_SUPPLIERS_FAILURE: 'GET_SUPPLIERS_FAILURE',

    ADD_CUSTOMERS_FILTER: 'ADD_CUSTOMERS_FILTER',

    GET_SUPPLIER_REQUEST: 'GET_SUPPLIER_REQUEST',
    GET_SUPPLIER_SUCCESS: 'GET_SUPPLIER_SUCCESS',
    GET_SUPPLIER_FAILURE: 'GET_SUPPLIER_FAILURE',


    GET_EXCEL_SUPPLIERS_REQUEST: 'GET_EXCEL_SUPPLIERS_REQUEST',
    GET_EXCEL_SUPPLIERS_SUCCESS: 'GET_EXCEL_SUPPLIERS_SUCCESS',
    GET_EXCEL_SUPPLIERS_FAILURE: 'GET_EXCEL_SUPPLIERS_FAILURE',

};
